import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from "@angular/http";
import {EngineM} from "../model/engine.model";
import {Util} from "../util/util";


@Injectable()
export class EngineService {

  headers = new Headers();
  options: RequestOptions;

  constructor(private http: Http) {
    this.headers.append('Content-Type', 'application/json');
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }

  reloadToken() {
    this.headers = Util.setHeaderToken(this.headers)
    this.options = new RequestOptions({headers: this.headers});
  }


  getAll(searchStr: string, status: string, buyer_id: number = 0, seller_id: number = 0, stamp: number = 9, startDate: string, endDate: string, offset = 0, limit = 30, orderBy = 'desc') {
    this.reloadToken()
    return this.http.get(`/api/engine/list?searchStr=${searchStr}&status=${status}&buyer_id=${buyer_id}&seller_id=${seller_id}&engine_no_stamp=${stamp}&startDate=${startDate}&endDate=${endDate}&offset=${offset}&limit=${limit}&orderBy=${orderBy}`, this.options).map(res => res.json());
  }

  getDetail(id: string) {
    this.reloadToken()
    return this.http.get(`/api/engine/detail/${id}`, this.options).map(res => res.json());
  }

  updateStatus(item: EngineM) {
    this.reloadToken()
    return this.http.put(`/api/engine/status/${item.id}/${item.status}`, item, this.options).map(res => res.json());
  }

  getLongList() {
    this.reloadToken()
    return this.http.get(`/api/engine/longList`, this.options).map(res => res.json());
  }

  getShortList() {
    this.reloadToken()
    return this.http.get(`/api/engine/shortList`, this.options).map(res => res.json());
  }

  saveEngineSeller(item) {
    this.reloadToken()
    return this.http.put(`/api/engine/updateEngineSeller`, item, this.options).map(res => res.json())
  }

}



// WEBPACK FOOTER //
// ./src/app/services/engine.service.ts